import React from "react"
import MyUIHelpers from "src/core/components/MyUI/MyUIHelpers"
import { CSuppense } from "src/core/components"

const MUI_dev_simulator = React.lazy(() => import("./Types/dev_simulator"))

const MyUIOne = {
  init() {
    MyUIHelpers.addTypes("dev_simulator", props => {
      return CSuppense(props, MUI_dev_simulator)
    })
  },
}

export default MyUIOne
